import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { pluck } from 'rxjs/operators';
import { PublicNoteResolveData } from './create-public-notes-resolve';
import { Observable } from 'rxjs';
import { format } from 'date-fns';

@Component({
  selector: 'messaging-service-public-notes-list',
  templateUrl: './public-list.component.html',
  styleUrls: ['./public-list.component.scss']
})
export class PublicNotesListComponent implements OnInit {
  data$: Observable<PublicNoteResolveData>;

  @Input()
  dateFormat = (date: Date) => format(date, 'HH:mm:ss, dd-MM-y');

  @Input()
  showCreated = false;

  @Input()
  showModified = false;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.data$ = this.route.data.pipe(
      pluck<{ data: PublicNoteResolveData }, PublicNoteResolveData>('data'),
    );
  }

}
